<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
        <div class="well form-group" style="background: #e5e9ec">

            <!--title -->
            <div class="grid-title no-border borderTop">
                <h4 style="padding-left: 6px"> {{ i18nValues["orderEdition"] }} </h4>
            </div>  

            <!-- body -->
            <div class="grid-body no-border borderBottom">
                <el-form v-loading="loading != 0" :model="order" ref="formOrder" :rules="rules">
                    <div class="gridTemplate">

                        <!-- Code --> 
                        <el-form-item :label="i18nValues['orderNumber']" prop="id">
                            <el-input v-model="order.id" disabled></el-input>
                        </el-form-item>

                        <!-- Status --> 
                        <el-form-item :label="i18nValues['status']" prop="status">
                            <el-input v-model="order.status" :placeholder= "this.i18nValues['open']" disabled></el-input>
                        </el-form-item>

                        <!-- DispatchDate -->
                        <el-form-item :label="i18nValues['dispatchDate']" prop="dispatchDate">
                            <div class="input-group">
                                <el-date-picker 
                                    type="date" 
                                    class="calendar"
                                    format="dd/MM/yyyy"
                                    v-model="order.dispatchDate"
                                    placeholder="Select date">
                                </el-date-picker>
                                <span class="input-group-addon primary el-input__suffix icon">
                                <span class="arrow"></span>
                                    <i class="fa fa-calendar-alt"></i>
                                </span>                                
                            </div>
                        </el-form-item>
                          
                        <!-- DispatchType -->                
                        <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType" v-if="isOpen == true && this.PalletItemsList.length == 0">
                            <el-select v-model="order.dispatchType" placeholder="Please select">
                                <el-option
                                    v-for="item in dispatchTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>     
                    
                        <!-- DispatchType --> 
                        <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType" v-if="isOpen == false || this.PalletItemsList.length != 0">
                            <el-input v-model="order.dispatchType" disabled></el-input>
                        </el-form-item>

                        <!-- Destination --> 
                        <el-form-item :label="i18nValues['destination']" prop="destination">
                            <el-input v-model="order.destination" ></el-input>
                        </el-form-item>

                        <!-- Vessel --> 
                        <el-form-item :label="i18nValues['vessel']" prop="vessel" v-if="order.dispatchType == 'ship' || order.dispatchType == 'Barco'">
                            <el-input v-model="order.vessel" ></el-input>
                        </el-form-item>

                        <!-- ETD -->
                        <el-form-item label="ETD" prop="estimatedTimeDelivery">
                            <div class="input-group">
                                <el-date-picker 
                                    type="date" 
                                    class="calendar"
                                    format="dd/MM/yyyy"
                                    v-model="order.estimatedTimeDelivery"
                                    placeholder="Select date">
                                </el-date-picker>
                                <span class="input-group-addon primary el-input__suffix icon">
                                <span class="arrow"></span>
                                    <i class="fa fa-calendar-alt"></i>
                                </span>                                
                            </div>
                        </el-form-item>

                        <!-- ETA -->
                        <el-form-item label="ETA" prop="estimatedTimeArrival">
                            <div class="input-group">
                                <el-date-picker 
                                    type="date" 
                                    class="calendar"
                                    format="dd/MM/yyyy"
                                    v-model="order.estimatedTimeArrival"
                                    placeholder="Select date">
                                </el-date-picker>
                                <span class="input-group-addon primary el-input__suffix icon">
                                <span class="arrow"></span>
                                    <i class="fa fa-calendar-alt"></i>
                                </span>                                
                            </div>
                        </el-form-item>
                        
                        <!-- Observations --> 
                        <el-form-item :label="i18nValues['observations']" prop="observations">
                            <el-input v-model="order.observations"></el-input>
                        </el-form-item>
                    </div>    
                    
                    <!-- Customer --> 
                    <div class="gridTemplate">
                    <el-form-item :label="i18nValues['customer']" prop="customer">   
                            <el-select v-model="order.customer.id" placeholder="Please select" filterable>
                                <el-option :value="null"></el-option>
                                    <el-option
                                        v-for="item in CustomersList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>                   
                    </el-form-item>

                    <!-- Subsidiary --> 
                    <el-form-item :label="i18nValues['supplier']" prop="supplier">   
                            <el-select v-model="order.supplier.id" placeholder="Please select" filterable>
                                <el-option :value="null"></el-option>
                                    <el-option
                                        v-for="item in SuppliersList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>              
                    </el-form-item>

                    <!-- Status --> 
                      <el-form-item :label="i18nValues['invoice']" prop="invoice">
                         <el-input v-model="order.invoice" :placeholder= "this.i18nValues['invoice']"></el-input>
                      </el-form-item>
                    </div>

                    <!-- CarrierCompany --> 
                    <div class="gridTemplate">                        
                        <el-form-item :label="i18nValues['carrierCompany']" prop="carrierCompany">
                            <el-select v-model="order.carrierCompany.id" placeholder="Please select" filterable>
                                <el-option :value="null"></el-option>
                                <el-option
                                    v-for="item in CarriersList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>   
                        
                        <!-- DriverName --> 
                        <el-form-item :label="i18nValues['driverName']" prop="driverName">
                            <el-input v-model="order.driverName" maxlength="30"></el-input>
                        </el-form-item>
                            
                        <!-- TruckPlate --> 
                        <el-form-item :label="i18nValues['truckPlate']" prop="truckPlate">
                            <el-input v-model="order.truckPlate" maxlength="8"></el-input>
                        </el-form-item>
                           
                        <!-- TrailerPlate -->    
                        <el-form-item :label="i18nValues['trailerPlate']" prop="trailerPlate">
                            <el-input v-model="order.trailerPlate" maxlength="8"></el-input>
                        </el-form-item> 

                        <!-- DeliveryNumber -->    
                        <el-form-item v-if="order.dispatchType == 'plane' || order.dispatchType == 'Avion' "  :label="i18nValues['deliveryNumber']" prop="deliveryNumber">
                            <el-input v-model="order.deliveryNumber" maxlength="7"></el-input>
                        </el-form-item> 

                        <!-- AirGuide -->    
                        <el-form-item v-if="order.dispatchType == 'plane' || order.dispatchType == 'Avion' "  :label="i18nValues['airGuide']" prop="guide">
                            <el-input v-model="order.airGuide" maxlength="12"></el-input>
                        </el-form-item>   
                        
                        <!-- Container -->    
                        <el-form-item v-if="order.dispatchType == 'ship' || order.dispatchType == 'Barco' "  :label="i18nValues['container']" prop="container">
                            <el-input v-model="order.container" maxlength="14"></el-input>
                        </el-form-item> 

                        <!-- Precinct Number -->    
                        <el-form-item v-if=" (this.isOpen == true || this.isForDispatch == true) && (order.dispatchType == 'ship' || order.dispatchType == 'Barco')"  :label="i18nValues['precinctNumber']" prop="precinctNumber">
                            <el-input v-model="order.precinctNumber" maxlength="11"></el-input>
                        </el-form-item> 

                        <!-- Precinct Number -->    
                        <el-form-item v-if="(this.isOpen == false && this.isForDispatch == false) && (order.dispatchType == 'ship' || order.dispatchType == 'Barco')" :label="i18nValues['precinctNumber']" prop="precinctNumber">
                            <el-input v-model="order.precinctNumber" maxlength="11"></el-input>
                        </el-form-item> 

                          <!-- DNI Driver -->    
                          <el-form-item :label="i18nValues['driverDNI']" prop="driverDNI">
                            <el-input v-model="order.driverDNI" ></el-input>
                        </el-form-item> 
                    </div>

                    <div style="margin-bottom: 10px;">
                        <h6>{{ i18nValues['pallets'] }}</h6>
                    </div>
                       
                    <!-- Show Pallets Table -->
                    <div class="full-width" style="margin:0 auto;padding:20px;">
                    <el-table v-if="PalletItemsList.length != 0"
                      :data="PalletItemsList"
                      style="width: 100%;margin-bottom: 20px;"
                      row-key="id"       
                      class="table table-hover table-striped"
                      align="center"
                      :header-cell-style="{ textAlign: 'center', whiteSpace: 'nowrap' }"
                      :empty-text="i18nValues['noDataAvailable']"     
                      :tree-props="{children: 'items'}">                     

                      <!-- PALLET -> ITEM -> PRODUCT.NAME -->
                      <el-table-column 
                        prop="product.name"
                        :label= "i18nValues['variety']"
                        sortable
                        align="left"
                        show-overflow-tooltip
                        width="120">
                      </el-table-column>

                      <!-- PALLET -> ITEM -> BRAND.NAME -->
                      <el-table-column
                        prop="product.brand"
                        label = "Brand"
                        sortable
                        align="left"
                        show-overflow-tooltip
                        width="120">
                      </el-table-column>

                      <!-- PALLET -> ITEM -> EVENT.NAME -->
                      <el-table-column
                        prop="product.event.name"
                        :label="i18nValues['event']"
                        sortable
                        align="left"
                        show-overflow-tooltip
                        width="120">
                      </el-table-column> 
                      
                      <!-- PALLET ID -->
                      <el-table-column
                        :formatter = "formatPalletId"
                        :label="i18nValues['code']"
                        sortable
                        align="right"
                        show-overflow-tooltip
                        width="100">
                      </el-table-column>    
                      
                      <!-- PALLET ID NUMBER -->
                      <el-table-column
                        prop="idNumber"
                        :label="i18nValues['idNumber']"
                        show-overflow-tooltip
                        width="60"
                        align="right"
                      ></el-table-column>   

                      <!-- PALLET -> ITEM -> BATCH-->
                      <el-table-column
                        prop="batch"
                        :label="i18nValues['batch']"
                        sortable
                        align="right"
                        show-overflow-tooltip
                        width="80">
                      </el-table-column>                     

                      <!-- PALLET + ITEM -> NETWEIGHT -->
                      <el-table-column
                        prop="netWeight"
                        :label="i18nValues['netWeight']"
                        sortable
                        align="right"
                        show-overflow-tooltip
                        width="110">
                      </el-table-column>      
                      
                      <!-- PALLET + ITEM -> GROSSWEIGHT -->
                      <el-table-column
                        prop="grossWeight"
                        :label="i18nValues['grossWeight']"
                        sortable
                        align="right"
                        show-overflow-tooltip
                        width="125">
                      </el-table-column>  

                      <!-- BAGS NUMBER-->
                      <el-table-column
                        prop="bagsNumber" 
                        :label="i18nValues['numberOfBags']"
                        sortable
                        align="right"
                        show-overflow-tooltip
                        width="170">
                      </el-table-column>  

                      <!-- PALLET TYPE -->
                        <el-table-column
                          prop="palletType" 
                          :label="i18nValues['palletType']"
                          sortable
                          align="center"
                          show-overflow-tooltip
                          width="140">
                        </el-table-column>  

                        <!-- DELETE -->
                        <el-table-column width="90" align="right" v-if="isOpen">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isPallet && scope.row.status != 'loaded' && scope.row.status != 'Cargado' && scope.row.status != 'dispatched' && scope.row.status != 'Enviado' "
                                    class="text-danger"
                                    icon="fas fa-times"
                                    size="small"
                                    align="center"
                                    title="desasociar"
                                    @click="disassociate(scope.row)"
                                ></el-button>
                            </template>
                        </el-table-column>                         
                    </el-table>   
                    
                    <p align="center" v-else>{{ i18nValues['addPallets'] }}</p>

                    <!-- Total Pallets Count -->
                    <div v-if="totalPalletsCount > 0" style="display: flex; justify-content: flex-end; margin-top: 10px;">
                        <span style="color: #555; font-size: 12px;"> {{ i18nValues['totalPallets'] }}: {{ totalPalletsCount }}</span>
                    </div>

                    </div>

           
            <!-- PICTURE/CANCEL/OTHER BUTTONS --> 
            <div class="full-width mt-2" style="display: flex; justify-content: space-between; align-items: center;">
              <div v-if="this.order.precinctPicture != null">
                <el-button type="primary" style="background-color:grey; border-color:grey; padding: 7px; width: 90px" @click="showPicture()">
                  {{ i18nValues["picture"] }}
                </el-button>
              </div>
              <div v-else style="width: 100%;"> 
              </div>

            <div class="d-flex justify-content-end">
                <el-button :loading="loading" size="small" @click="cancel()">
                    {{ i18nValues["cancel"] }}
                </el-button>
                <el-button v-if=" !isOpen && componentsMap.get('reopen_order')" icon="fas fa-redo" size="small" class="btn-primary" @click="handleReopenOrder()">
                  {{ i18nValues["reopenOrder"] }}
                </el-button>
                <el-button v-if=" isOpen && componentsMap.get('change_order_dispatch')" icon="fas fa-exchange-alt" size="small" class="btn-primary" @click="toggleDispatch">
                    {{ i18nValues["toggleDispatchType"] }}
                </el-button>
                <el-button class="btn-primary" v-if=" isOpen && componentsMap.get('order_create') && (order.dispatchType == 'plane' || order.dispatchType == 'Aéreo' || order.dispatchType == 'Avion')" type="primary" @click="turnVisible()" icon="fas fa-plus" size="mini">
                    {{ i18nValues["addPallets"] }}
                </el-button>
                <el-button
                  icon="fas fa-print"
                  size="small"
                  class="btn-primary"
                  v-if="this.order.dispatchType == 'plane' && this.order.deliveryNumber != null"
                  @click="printFlight()"
                >
                  {{ i18nValues["printFlight"] }}
                </el-button>   
                <el-button v-if="!isReadOnly()" icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
                    {{ i18nValues["save"] }}
                </el-button>      
                <el-button v-if=" isOpen && componentsMap.get('order_to_dispatch') " type="primary" style="background-color:grey; border-color:grey" @click="dispatch()" icon="fas fa-check" size="mini">
                    {{ i18nValues["forDispatch"] }}
                </el-button>        
                <el-button v-if="!isReadOnly() && isDispatched " type="primary" style="background-color:grey; border-color:grey" @click="inPort()" icon="fas fa-check" size="mini">
                    {{ i18nValues["inPort"] }}
                </el-button>   
                <el-button v-if=" isInPort" type="primary" style="background-color:grey; border-color:grey" @click="arrivedToDestination()" icon="fas fa-check" size="mini">
                    {{ i18nValues["arrivedToDestination"] }}
                </el-button>                
            </div>   
          </div>                   
        </el-form>               
            </div>                  
        </div>

        <img v-if="imageUrl" :src="imageUrl" alt="Precinct Picture">
        
        <!-- Pallets Modal -->  
        <PalletModal
            :modalTitle="i18nValues['pallets']"
            :visible.sync="visiblePallets"
            :id="order.id"
            :PalletItemsList="this.PalletItemsList"
            :dispatchType="order.dispatchType"
            ref="palletModal"
            actionIcon="fas fa-edit"
            actionTitle="edit"
            @pallets-updated="updatePalletsCount"
        ></PalletModal>
    </div>   
</template>

<script>
import { get } from "vuex-pathify";
import PalletModal from "../../components/customer/invoicingmodule/modals/PalletModal.vue"; // eslint-disable-line no-unused-vars
export default {
  name: "OrdersEdition",

  async created() {
    console.log(this.user); //eslint-disable-line
    if (this.id != 0) {
      this.retrieveById();
      console.log(this.order); //eslint-disable-line
    } else {
      this.order.status = "Abierto";
      this.order.creationUser = this.user.name;
      this.order.creationDate = new Date();
      // console.log(this.order)//eslint-disable-line
    }

    this.rules = {
      dispatchType: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],

      customer: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.i18nValues["requiredValue"]));
            } else if (!value.id) {
              callback(new Error(this.i18nValues["requiredValue"]));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],

      supplier: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.i18nValues["requiredValue"]));
            } else if (!value.id) {
              callback(new Error(this.i18nValues["requiredValue"]));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],

      dispatchCode: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],

      deliveryNumber: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],

      dispatchDate: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
    };

    this.retrieveCustomers();
    this.retrieveCarriers();
    this.retrievePalletItems();
    this.retrieveSuppliers();
    //console.log(this.id);//eslint-disable-line
  },

  components: {
    PalletModal,
  },

  computed: {
    loading: get("order/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),

    dispatchTypeOptions() {
          return [
            { id: 1, value: "plane", label: this.i18nValues['aerial']   },
            { id: 2, value: "ship", label: this.i18nValues['maritime'] },
          ];
    }
  },

  props: {
    id: null,
    componentsMap: {},
  },
  //props:["id"],

  data() {
    return {
      imageUrl: null,
      visiblePallets: false,
      CustomersList: [],
      CarriersList: [],
      PalletItemsList: [],
      PalletToDisassociate: [],
      supplierId: null,
      totalPalletsCount: 0,

      hasPallets: false,
      isOpen: true,
      isInPort: false,
      isForDispatch: true,
      isDispatched: false,

      notForDispatch: true,

      order: {
        customer: {},
        supplier: {},
        carrierCompany: {},
        dispatchType: "plane",
        pallets: [{}],
      },

      // dispatchTypeOptions: [
      //   { value: "plane", label: this.i18nValues['aerial']  },
      //   { value: "ship", label: this.i18nValues['maritime'] },
      // ],

      SuppliersList: [],
    };
  },

  methods: {
    updatePalletsCount() {
      this.totalPalletsCount = this.PalletItemsList.filter(item => item.isPallet).length;
    },

    save() { 
      if (this.order.status == null || this.order.status == "Abierto") {
        this.order.status = "open";
      }
      if (this.order.status == "Para Despachar") {
        this.order.status = "forDispatch";
      }
      if (this.order.status == "Despachado") {
        this.order.status = "dispatched";
      }
      if (this.order.status == "En Puerto") {
        this.order.status = "inPort";
      }
      if (this.order.status == "Recibido en Destino") {
        this.order.status = "arrivedToDestination";
      }
      if (this.order.dispatchType == "Avion") {
        this.order.dispatchType = "plane";
      }
      if (this.order.dispatchType == "Barco") {
        this.order.dispatchType = "ship";
      }
      this.order.pallets = this.PalletItemsList;
      this.order.fieldSite = this.globalFieldSite;
      this.order.campaign = {id : this.globalCampaign ? this.globalCampaign.id : null};
      
      this.$refs["formOrder"].validate((valid) => { 
        if (valid) {
          this.$store.dispatch("order/saveOrder", this.order).then((res) => {
        if (res.status == "OK") {
          this.order.id = res.statusId;
          this.$notify.success({
            title: this.i18nValues["succes"],
            message: this.i18nValues["orderSaved"],
            position: "bottom-right",
          });
          if (this.notForDispatch) {
            this.$router.push({ name: "OrdersAdmin", query: this.$route.query });
          }
          for (var i = 0 ; i < this.PalletToDisassociate.length ; i++){
            this.PalletToDisassociate[i].status = "available";
            this.$store.dispatch("pallet/savePallet", this.PalletToDisassociate[i])
          }
          this.$router.push({ name: "OrdersAdmin", query: this.$route.query });
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: res.statusDescription,
            position: "bottom-right",
          });
        }
        });
        }
      });

    },

    cancel() {
      this.$router.push({ name: "OrdersAdmin", query: this.$route.query });
    },

    retrieveById() {
      this.$store
        .dispatch("order/retrieveById", { id: this.id })
        .then((res) => {
          this.order = res;
          this.order.modificationUser = this.user.name;
          this.order.modificationDate = new Date();
          if (this.order.supplier == null) {
            this.order.supplier = {};
          }
          if (this.order.customer == null) {
            this.order.customer = {};
          }
          if (this.order.carrierCompany == null) {
            this.order.carrierCompany = {};
          }
          this.disable();
          if (this.order.status == "open") {
            this.order.status = this.i18nValues["open"];
          }
          if (this.order.status == "forDispatch") {
            this.order.status = this.i18nValues["forDispatch"];
          }
          if (this.order.status == "dispatched") {
            this.order.status = this.i18nValues["dispatched"];
            this.isDispatched = true;
          }
          if (this.order.status == "inPort") {
            this.order.status = this.i18nValues["inPort"];
            this.isInPort = true;
          }
          if (this.order.status == "arrivedToDestination") {
            this.order.status = this.i18nValues["arrivedToDestination"];
          }
          // if (this.order.dispatchType == "plane") {
          //   this.order.dispatchType = this.i18nValues["plane"];
          // }
          // if (this.order.dispatchType == "ship") {
          //   this.order.dispatchType = this.i18nValues["ship"];
          // }
        });
    },

    retrieveCustomers() {
      this.$store.dispatch("customer/retrieveCustomers").then((res) => {
        this.CustomersList = res;
      });
    },

    retrieveCarriers() {
      this.$store.dispatch("carrier/retrieveCarrierCompanys").then((res) => {
        this.CarriersList = res;
      });
    },

    retrieveSuppliers() {
      this.$store.dispatch("supplier/retrieveSuppliers").then((res) => {
        this.SuppliersList = res;
      });
    },

    retrievePalletItems() {
      if (this.id != 0) {
        this.$store
          .dispatch("pallet/retrievePalletswithOrders", { id: this.id })
          .then((res) => {
            this.PalletItemsList = res;
            for(var i = 0; i < this.PalletItemsList.length; i++){
              this.PalletItemsList[i].code = this.PalletItemsList[i].id;
            }
            this.updatePalletsCount();
          });
        //console.log(this.order.pallets); //eslint-disable-line
      } else {
        this.PalletItemsList = [];
        this.updatePalletsCount();
      }
    },

    disassociate(pallet) {
      this.PalletToDisassociate.push(pallet);
      this.PalletItemsList.splice(this.PalletItemsList.indexOf(pallet), 1);
      this.updatePalletsCount();
    },

    turnVisible() {
      this.visiblePallets = true;
      this.$refs.palletModal.retrievePalletItems();
    },

    dispatch() {
      this.order.status = "forDispatch";
      this.notForDispatch = false;
      this.save();
      this.order.status = "Para Despachar";
    },

    inPort() {
      this.order.status = "inPort";
      this.save();
    },

    arrivedToDestination() {
      this.order.status = "arrivedToDestination";
      this.save();
    },

    disable() {
      if (this.order.status == "open" || this.order.status == "Abierto" || this.order.status == "Open") {
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
      if (
        this.order.status == "forDispatch" ||
        this.order.status == "Para Despachar"
      ) {
        this.isForDispatch = true;
      } else {
        this.isForDispatch = false;
      }
      //console.log(this.isOpen);//eslint-disable-line
      //console.log(this.isForDispatch);//eslint-disable-line
    },

    printFlight() {
      this.$store
        .dispatch("order/downloadPDF", this.order.id)
        .then((res) => {
          if (res.size == 0) {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["errorDownload"],
              position: "bottom-right",
              duration: 7000,
            });
          } else {
            var blob = new Blob([res], { type: "application/pdf" });
            const links = document.createElement("a");
            links.href = URL.createObjectURL(blob);
            links.download = "Orden_" + this.order.id + (this.order.deliveryNumber ? "_ENVIO_" + this.order.deliveryNumber : "");
            links.click();
            URL.revokeObjectURL(links.href);
          }
          this.$router.push({ name: "OrdersAdmin", query: this.$route.query });
        });
      this.$notify.success({
        title: this.i18nValues["succes"],
        message: this.i18nValues["printSuccess"],
        position: "bottom-right",
      });
    },

    formatPalletId(row){
          return row.id;
    },

    showPicture() {
      this.$store.dispatch("order/showPrecinctPicture", this.order.id)
        .then((blob) => {
          if (blob.size == 0) {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["errorDownload"],
                  position: "bottom-right",
                  duration: 7000,
                });
              } else {
            const imageUrl = URL.createObjectURL(blob);
            window.open(imageUrl, '_blank');
          }}
    )},

    handleReopenOrder() {
      this.$store.dispatch("order/reopenOrder", this.order.id)
        .then((res) => {
          if (res.status === "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["orderReopened"], 
              position: "bottom-right",
            });
            this.retrieveById();
            this.retrievePalletItems();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: res.statusDescription,
              position: "bottom-right",
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: error.message,
            position: "bottom-right",
          });
        });
    },

    toggleDispatch() {
      this.$store.dispatch("order/toggleDispatchType", this.order.id)
        .then((res) => {
          if (res.status === "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["orderDispatchTypeChanged"], 
              position: "bottom-right"
            });
            this.retrieveById();
            this.retrievePalletItems();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: res.statusDescription,
              position: "bottom-right"
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: error.message,
            position: "bottom-right"
          });
        });
    },

  },
};
</script>

<style scoped>
/* Prevent header labels and cell text from wrapping and show ellipsis */
.el-table th .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.el-table td .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
